var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.079,
    height: 170.079,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.948 101.109c-.07-9.091 1.569-17.533 5.816-25.347 5.409-9.952 13.7-16.475 24.472-19.663 11.449-3.388 22.938-3.142 34.159 1.075 11.635 4.372 19.583 12.57 23.991 24.173 3.088 8.131 3.751 16.576 3.047 25.175-.6 7.322-2.59 14.226-6.357 20.562-5.523 9.288-13.654 15.211-23.938 18.236-6.723 1.979-13.604 2.41-20.577 1.851-7.458-.601-14.464-2.606-20.837-6.574-8.561-5.33-14.118-13.001-17.254-22.502-1.846-5.599-2.578-11.368-2.522-16.986zm67.621-.26c-.396-3.355-.654-6.734-1.219-10.062-.801-4.725-2.562-9.083-5.966-12.578-5.899-6.058-13.173-7.052-20.936-5.049-6.401 1.651-10.474 6.212-12.659 12.262-3.278 9.08-3.265 18.391-1.021 27.706 1.089 4.516 3.202 8.519 6.741 11.648 4.001 3.538 8.785 4.621 13.984 4.491 8.125-.205 14.031-3.864 17.558-11.21 2.606-5.425 3.198-11.256 3.518-17.208zM48.661 145H24.398v-1.294c0-28.63.005-57.26-.02-85.891 0-1.031.218-1.407 1.336-1.399 7.284.05 14.568.025 21.852.028.342 0 .684.037 1.095.062V145zM24.475 22.682h24.168v20.024H24.475V22.682z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIo);
export default __webpack_public_path__ + "static/media/logo-io.9d58e00890cdefa6da9594f26ad33964.svg";
export { ForwardRef as ReactComponent };